(function () {
  'use strict';

  document.documentElement.classList.add('col-js');

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var root = document.querySelector('[data-col-root]');
    if (!root) return;

    // --- Auto-submit: filters ------------------------------------------------
    var filtersForm = root.querySelector('[data-col-filters]');
    if (filtersForm) {
      var debounce;
      filtersForm.addEventListener('change', function (event) {
        var target = event.target;
        if (target && target.type === 'number') return; // handled on input/blur
        filtersForm.submit();
      });
      filtersForm.addEventListener('input', function (event) {
        var target = event.target;
        if (!target || target.type !== 'number') return;
        window.clearTimeout(debounce);
        debounce = window.setTimeout(function () {
          filtersForm.submit();
        }, 700);
      });
    }

    // --- Auto-submit: sort ---------------------------------------------------
    var sortForm = root.querySelector('[data-col-sort]');
    var sortSelect = root.querySelector('[data-col-sort-select]');
    if (sortForm && sortSelect) {
      sortSelect.addEventListener('change', function () {
        sortForm.submit();
      });
    }

    // --- Mobile filter drawer ------------------------------------------------
    var toggle = root.querySelector('#ColFilterToggle');
    var drawer = root.querySelector('#ColFilters');
    var openers = root.querySelectorAll('[data-col-drawer-open]');

    if (toggle && drawer) {
      var focusableSel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

      function isOpen() {
        return toggle.checked;
      }

      function setExpanded(state) {
        openers.forEach(function (el) {
          el.setAttribute('aria-expanded', state ? 'true' : 'false');
        });
      }

      function onToggle() {
        if (isOpen()) {
          /* Единый владелец scroll-lock — documentElement, как в cart.js */
          document.documentElement.style.overflow = 'hidden';
          setExpanded(true);
          var first = drawer.querySelector(focusableSel);
          if (first) first.focus();
        } else {
          document.documentElement.style.overflow = '';
          setExpanded(false);
        }
      }

      toggle.addEventListener('change', onToggle);

      // Keyboard-activate the label "buttons".
      openers.forEach(function (el) {
        el.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggle.checked = !toggle.checked;
            onToggle();
          }
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen()) {
          toggle.checked = false;
          onToggle();
          if (openers[0]) openers[0].focus();
        }
      });

      // Simple focus trap while the drawer is open.
      drawer.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab' || !isOpen()) return;
        var items = drawer.querySelectorAll(focusableSel);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }
  });
})();
